<div
  class="min-h-screen bg-gradient-to-br from-[#faf5ff] via-white to-[#e1d5fa] flex items-center justify-center p-4 py-8">
  <div *ngIf="loading" class="flex flex-col items-center gap-3">
    <svg class="h-10 w-10 animate-spin text-[#4c1d95]" xmlns="http://www.w3.org/2000/svg" fill="none"
      viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z"></path>
    </svg>
    <p class="text-sm font-medium text-[#4c1d95]">Loading checkout...</p>
  </div>

  <div *ngIf="!loading" class="w-full max-w-lg shadow-2xl border border-[#e1d5fa] bg-white rounded-lg">
    <div class="p-6 sm:p-8">
      <div class="mb-6 pb-6 border-b border-[#e1d5fa]">
        <div class="flex items-start gap-4 mb-4">
          <div *ngIf="billData?.logo"
            class="relative h-16 w-16 rounded-lg overflow-hidden bg-[#f3f4f6] border border-[#e1d5fa] flex-shrink-0">
            <img
              [src]="billData?.logo?.startsWith('http') ? billData?.logo : 'http://193.46.243.80:8080/assets/images/scripay-logo.png'"
              alt="Bill Logo" class="object-contain p-2 w-full h-full">
          </div>
          <div class="flex-1 min-w-0">
            <h1 class="text-xl sm:text-2xl font-bold text-[#1e1b4b] mb-1 break-words">{{ billData?.name || 'Bill
              Payment' }}</h1>
            <p class="text-sm text-gray-600 break-words">{{ billData?.description || 'Complete your payment' }}</p>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div class="bg-[#faf5ff] p-3 rounded-lg">
            <p class="text-gray-600 text-xs mb-1">Amount</p>
            <p class="font-semibold text-[#1e1b4b]">KES {{ billData?.amount?.toLocaleString() || 0 }}</p>
          </div>
          <div class="bg-[#faf5ff] p-3 rounded-lg">
            <p class="text-gray-600 text-xs mb-1">Status</p>
            <p [ngClass]="billData?.status === 'FullyPaid' ? 'text-[#16a34a]' : 'text-[#dc2626]'" class="font-semibold">
              {{ billData?.status || 'Unknown' }}
            </p>
          </div>
          <div class="bg-[#faf5ff] p-3 rounded-lg">
            <p class="text-gray-600 text-xs mb-1">Paid</p>
            <p class="font-semibold text-[#1e1b4b]">KES {{ billData?.amount_paid?.toLocaleString() || 0 }}</p>
          </div>
          <div class="bg-[#faf5ff] p-3 rounded-lg">
            <p class="text-gray-600 text-xs mb-1">Balance</p>
            <p class="font-semibold text-[#4c1d95]">KES {{ billData?.balance?.toLocaleString() || 0 }}</p>
          </div>
        </div>
      </div>

      <div class="mb-6">
        <h3 class="text-base font-semibold text-[#1e1b4b] mb-2">Payment Method</h3>
        <div class="border-2 border-[#a855f7] rounded-lg p-4 flex items-center gap-4 bg-[#faf5ff]">
          <div class="relative h-12 w-16 flex-shrink-0">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/M-PESA_LOGO-01.svg/1200px-M-PESA_LOGO-01.svg.png"
              alt="M-Pesa" class="object-contain w-full h-full">
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-sm font-semibold text-[#1e1b4b]">Pay with Safaricom M-Pesa</h4>
            <p class="text-xs text-gray-600 mt-1">M-Pesa is currently the only form of payment</p>
          </div>
        </div>
      </div>

      <div *ngIf="success"
        class="mb-6 bg-green-50 border border-green-300 text-green-800 rounded-lg p-4 flex items-center">
        <svg class="h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        <p class="ml-2">{{ successMessage || 'This bill is fully paid. No further action is needed.' }}</p>
      </div>

      <div *ngIf="polling"
        class="mb-6 bg-blue-50 border border-blue-300 text-blue-800 rounded-lg p-4 flex items-center">
        <svg class="h-5 w-5 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z"></path>
        </svg>
        <p class="ml-2">Checking payment status... Please wait.</p>
      </div>

      <div *ngIf="successMessage && !success && !polling"
        class="mb-6 bg-green-50 border border-green-300 text-green-800 rounded-lg p-4 flex items-center">
        <svg class="h-5 w-5 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        <p class="ml-2">{{ successMessage }}</p>
      </div>

      <div *ngIf="error" class="mb-6 bg-red-50 border border-red-300 text-red-800 rounded-lg p-4 flex items-center">
        <svg class="h-5 w-5 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
        <p class="ml-2">{{ error }}</p>
      </div>

      <form *ngIf="!success && billData" (ngSubmit)="onSubmit($event)" class="space-y-5">
        <div>
          <label for="amount" class="text-[#1e1b4b] font-medium">Amount (KES)</label>
          <input id="amount" type="number" [(ngModel)]="formData.amount" name="amount"
            [disabled]="!billData.allow_partial_payment" required
            class="mt-1.5 w-full border border-[#e1d5fa] focus:border-[#a855f7] focus:ring focus:ring-[#a855f7] focus:ring-opacity-50 rounded-md p-2"
            [ngClass]="{'bg-gray-100 cursor-not-allowed': !billData.allow_partial_payment}">
          <p *ngIf="!billData.allow_partial_payment" class="text-xs text-gray-500 mt-1">
            Partial payments are not allowed for this bill
          </p>
        </div>

        <div>
          <label for="name" class="text-[#1e1b4b] font-medium">Your Name <span
              class="text-gray-500 text-xs">(Optional)</span></label>
          <input id="name" type="text" [(ngModel)]="formData.name" name="name" placeholder="John Doe"
            class="mt-1.5 w-full border border-[#e1d5fa] focus:border-[#a855f7] focus:ring focus:ring-[#a855f7] focus:ring-opacity-50 rounded-md p-2">
        </div>

        <div>
          <label for="phone" class="text-[#1e1b4b] font-medium">Phone Number</label>
          <input id="phone" type="tel" [(ngModel)]="formData.phone" name="phone" placeholder="254700..." required
            class="mt-1.5 w-full border border-[#e1d5fa] focus:border-[#a855f7] focus:ring focus:ring-[#a855f7] focus:ring-opacity-50 rounded-md p-2">
        </div>

        <div>
          <label for="description" class="text-[#1e1b4b] font-medium">Description</label>
          <textarea id="description" [(ngModel)]="formData.description" name="description"
            placeholder="payment description ..." rows="3" required
            class="mt-1.5 w-full border border-[#e1d5fa] focus:border-[#a855f7] focus:ring focus:ring-[#a855f7] focus:ring-opacity-50 rounded-md p-2 resize-none"></textarea>
        </div>

        <button type="submit" [disabled]="submitting || polling"
          class="w-full bg-[#4c1d95] hover:bg-[#1e1b4b] text-white font-semibold py-6 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 flex items-center justify-center">
          <svg *ngIf="submitting || polling" class="mr-2 h-5 w-5 animate-spin" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-16 0z"></path>
          </svg>
          {{ submitting ? 'Processing Payment...' : polling ? 'Checking Status...' : 'Pay Now' }}
        </button>
      </form>
    </div>
  </div>
</div>